import { HTMLAttributes } from 'react'
import cn from 'classnames'
// Components
import styles from './Radio.module.scss'

export interface RadioOption {
  label: string
  value: string | boolean
}

interface RadioOptionProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange' | 'value'> {
  options: RadioOption[]
  value: string | number
  // eslint-disable-next-line no-unused-vars
  onChange: (option: RadioOption) => void
  inline?: boolean
  label?: string
  showError?: boolean
  errorMessage?: string
  inlineBox?: boolean
  bold?: boolean
  isMultiple?: boolean
}

export default function Radio({
  options,
  value,
  onChange,
  showError,
  errorMessage,
  inline,
  inlineBox,
  bold,
  className,
  isMultiple: _isMultiple,
}: RadioOptionProps) {
  const isMultiple = _isMultiple && Array.isArray(value) // Multiple
  return (
    <div
      className={cn({
        [styles.container]: true,
        [styles.inline]: inline,
        [styles.inlineBox]: inlineBox,
        [styles.hasErrorMessage]: !!errorMessage,
        [className]: className,
      })}
    >
      {options.map((option, i) => (
        <div
          key={i}
          className={cn({
            [styles.option]: true,
            [styles.three]: options.length === 3,
            [styles.active]: value === option.value,
            [styles.bold]: bold,
            [styles.warning]: !!showError,
          })}
          onClick={() => onChange?.(option)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              onChange?.(option)
            }
          }}
        >
          <div
            className={cn({
              [styles.checkbox]: true,
              [styles.active]: value === option.value,
            })}
          />

          {isMultiple && value.length
            ? value?.map((o) => o.label).join(', ')
            : option.label}
        </div>
      ))}

      {showError && !!errorMessage && (
        <div className={styles.error}>
          <div className={styles.icon} />
          <div className={styles.message}>{errorMessage}</div>
        </div>
      )}
    </div>
  )
}
